import { account } from '@silvertours/front-entities';
import { Dispatch, SetStateAction, createContext, useContext } from 'react';

export type LoginProps = {
  isLoggedIn: boolean;
  setLoggedIn: Dispatch<SetStateAction<boolean>>;
  showLogin: boolean;
  setShowLogin: (show: boolean) => void;
  showMobileLogin: boolean;
  setShowMobileLogin: (show: boolean) => void;
  username: string;
  setUsername: Dispatch<SetStateAction<string>>;
  error: account.LoginError | null;
  setError: Dispatch<SetStateAction<account.LoginError | null>>;
  securityToken: string;
};

const LoginContext = createContext<LoginProps | null>(null);

const useLogin = () => {
  const context = useContext(LoginContext);

  if (context === null) {
    throw new Error(
      'Ensure you have wrapped the login form in a LoginProvider',
    );
  }

  return context;
};

export { LoginContext, useLogin };
